import { render, staticRenderFns } from "./CreatorStats.vue?vue&type=template&id=5db45548&"
import script from "./CreatorStats.vue?vue&type=script&lang=js&"
export * from "./CreatorStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports